module.exports = __webpack_public_path__ + "assets/img/C3.26dbf865.png";